"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var store_1 = __importDefault(require("@store/store"));
//"https://gdd-creator-server-production.up.railway.app/api" deployed server
// "http://localhost:8801/api"
var axiosClient = axios_1.default.create({
    baseURL: "https://gdd-creator-server-production.up.railway.app/api",
    timeout: 10000,
    headers: { "Content-Type": "application/json" },
});
axiosClient.interceptors.request.use(function (config) {
    var _a, _b;
    var state = store_1.default.getState();
    var token = state.authSlice.token;
    var isPublicEndpoint = ((_a = config.url) === null || _a === void 0 ? void 0 : _a.includes("/login")) || ((_b = config.url) === null || _b === void 0 ? void 0 : _b.includes("/register"));
    if (token && !isPublicEndpoint) {
        config.headers.Authorization = "Bearer ".concat(token);
    }
    return config;
}, function (error) { return Promise.reject(error); });
axios_1.default.interceptors.response.use(function (res) {
    return res.data; // This was missing
}, function (error) {
    var _a;
    console.log("Axios error", ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
    return Promise.reject(error);
});
exports.default = axiosClient;
// baseURL:"http://localhost:8801/api",
